<div>
  <div nxModalContent>
    <h3 nxHeadline="subsection-large" class="nx-margin-bottom-m">Warning</h3>

    <p nxCopytext="normal" class="nx-margin-bottom-2m nx-font-weight-light">{{ message }}</p>
  </div>

  <div class="button-container-general">
    <button nxModalClose nxButton="secondary" type="button">CANCEL</button>
    <button nxModalClose nxButton="primary" type="button" (click)="onclickOK()">PROCEED</button>
  </div>
</div>
